class PaginatorController {

    constructor(
        $location
    ) {
        'ngInject';

        this.$location = $location;
    }

    /***
     * Update the paginator's page tracking and defaults back to page 1. This allows for two possible
     * scenarios:
     *
     * 1) a user first visits a page with a paginated list and we initialize it to the first page.
     * 2) a user is on a page where paginated data is dynamically loaded. As soon as the data list changes, this
     *    component will detect the change and update its maxPage and pageOptions.
     *
     */
    $onChanges(changes) {
        if ('itemListLength' in changes) {
            this.maxPage = Math.ceil(this.itemListLength / this.itemsPerPage);
            this.goToPage(1);
        }
    }

    /***
     * Loads the given page of Surveys. Takes into account current sorting parameter.
     *
     * @param pageNum   the page of survey results to display
     */
    goToPage(pageNum) {
        if (pageNum > 0 && pageNum <= this.maxPage) {
            this.$location.search('page', pageNum);
            this.currentPage = pageNum;
            const p = this.currentPage;
            this.pageOptions =
                [
                    p-2,
                    p-1,
                    p,
                    p+1,
                    p+2
                ]
                // Don't allow pages that are less than 0 or greater than the last page
                .filter((n) => { return (n > 0 && n <= this.maxPage); });

            const startingIndex = (this.currentPage - 1) * this.itemsPerPage;
            this.onUpdateStartingIndex({startingIndex: startingIndex});
        }
    }

}

export default PaginatorController;


// WEBPACK FOOTER //
// ./app/common/paginator/paginator-controller.js